import { render } from "./Col3.vue?vue&type=template&id=56dd9d38"
import script from "./Col3.vue?vue&type=script&lang=js"
export * from "./Col3.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__